import type { GridValueFormatter } from '@mui/x-data-grid-pro';
import { isEmpty } from 'lodash';

export const formatNoValue: GridValueFormatter = (value: string) => {
  if (isEmpty(value)) return '-';
  return value;
};
